export default __webpack_public_path__ + "static/media/coaching.c8a6edbd.svg";